import {Events, Requests} from '@/core-consts'

const protobuf = require("protobufjs/light")
const jsonDescriptor = require("@/bundle.json")

const root = protobuf.Root.fromJSON(jsonDescriptor)
let WebConMessage = root.lookupType("csproto.webconnector.WebMessage")
WebConMessage.Type = { REGISTER: 0, SEND: 1 }

let WebPayload = root.lookupType("csproto.webclient.WebPayload")
WebPayload.Type = { EVENT: 0, REQUEST: 1, REPLY: 2 }

let WebRequest = root.lookupType("csproto.webclient.WebRequest")

// events
let WebStateEvent = root.lookupType("csproto.webclient.WebStateEvent")
let WebAlertEvent = root.lookupType("csproto.webclient.WebAlertEvent")
let WebCallEvent = root.lookupType("csproto.webclient.WebCallEvent")
let WebAuthEvent = root.lookupType("csproto.webclient.WebAuthEvent")
let WebChatEvent = root.lookupType("csproto.webclient.WebChatEvent")
let WebVerifyEvent = root.lookupType("csproto.webclient.WebVerifyEvent")
let WebAvatarEvent = root.lookupType("csproto.webclient.WebAvatarEvent")
let WebAccountEvent = root.lookupType("csproto.webclient.WebAccountEvent")

// replies
let WebContact = root.lookupType("csproto.webclient.WebContact")
let WebContacts = root.lookupType("csproto.webclient.WebContacts")
let WebAccountDetails = root.lookupType("csproto.webclient.WebAccountDetails")
let WebChat = root.lookupType("csproto.webclient.WebChat")
let WebChats = root.lookupType("csproto.webclient.WebChats")
let WebMessage = root.lookupType("csproto.webclient.WebMessage")
let WebMessages = root.lookupType("csproto.webclient.WebMessages")
let WebFile = root.lookupType("csproto.webclient.WebFile")
let WebCalls = root.lookupType("csproto.webclient.WebCalls")
let WebExtra = root.lookupType("csproto.webclient.WebExtra")

const FRAGMENT_LEN = 64000

function bytesToHex(bytes) {
  for (var hex = [], i = 0; i < bytes.length; i++) {
      var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
      hex.push((current >>> 4).toString(16));
      hex.push((current & 0xF).toString(16));
  }
  return hex.join("");
}
function hexToBytes(hex) {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
  bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
}

class WebClient {
  constructor() {
    this.myToken = ''
    this.wscs = null
    this.messageCollector = {}
  }

  openWscs(url) {
    this.wscs = new WebSocket(url)
    this.wscs.binaryType = 'arraybuffer';
    return new Promise(resolve => {
      this.wscs.onopen = (ev) => {
        console.log('-- onopen', ev)
        resolve(true)
      }
      this.wscs.onmessage = (ev) => {
        console.log('-- wscsClient onmessage',ev.data)
        this.onMessageHandler(ev)
      }
      this.wscs.onerror = (ev) => {
        console.log('-- wscsClient onerror', ev)
        resolve(false)
      }
      this.wscs.onclose = (ev) => {
        console.log('-- wscsClient onclose', ev)
        // TODO: try counter
        var _this = this
        setTimeout(() => _this.reconnect(url), 1000)
      }
    })
  }

  reconnect(url) {
    this.openWscs(url).then((s) => {
      if (s) 
        this.registerWscs(this.myToken)
    })
  }

  registerWscs(token) {
    this.myToken = token

    let _this = this
    return new Promise(resolve => {
      function send() {
        const state = _this.wscs.readyState
        console.log('-- (ws send) state: ', state)
        
        if (state == WebSocket.OPEN) {
          _this.registerToken(token)
          resolve(true)
        } else if (state == WebSocket.CONNECTING) {
          setTimeout(send, 10)
        } else {
          resolve(false)
        }
      }
      send()
    })
  }

  onMessageHandler(ev) {
    const data = new Uint8Array(ev.data)
    const payload = WebPayload.decode(data)
    console.debug('-- recvd', payload.type, payload.action, payload.fragment, payload.fragmentCount)

    if (payload.fragmentCount > 0) {
      let key = payload.action
      if (!this.messageCollector[key]) {
        this.messageCollector[key] = {}
      }
      this.messageCollector[key][payload.fragment] = payload.cryptoBox

      // TODO: better to count frags in messageCollector and compare with fragmentCount
      const end = payload.fragment == (payload.fragmentCount - 1)
      if (!end)
        return
      
      let data = new Uint8Array()
      for (let i = 0; i < payload.fragmentCount; i++) {
        const b = this.messageCollector[key][i]
        const c = new Uint8Array(data.length + b.length);
        c.set(data);
        c.set(b, data.length);
        data = c
      }
      payload.cryptoBox = data
      this.messageCollector[key] = {}
    }

    if (payload.cryptoBox.length == 0 && payload.publicKey && payload.publicKey.length > 0) {
      console.log('-- store user key:', payload.publicKey)
      this.senderKey = payload.publicKey
      this.senderToken = payload.token
      // TODO: store both to storage
      this.onready()
    } else {
      if (payload.type == WebPayload.Type.EVENT) {
        this.onEventHandler(payload)
      } else if (payload.type == WebPayload.Type.REPLY) {
        this.onRequestHandler(payload)
      } else {
        console.error('-- unknown payload: ', payload)
      }
    }
  }

  onEventHandler(payload) {
    const bytes = window.cryptManager.decrypt(this.senderKey, payload.cryptoBox)
    console.debug('-- payload event:', payload.action, 'bytes', bytes.length)
    let msg = null

    switch (payload.action) {
      case Events.UserAuthorized:
        msg = WebAuthEvent.decode(bytes)
        console.log('-- userAuthorized', msg)
        this.onuserauthorized(msg)
        break

      case Events.StatusChanged:
        msg = WebStateEvent.decode(bytes)
        this.onstatuschanged(msg)
        break
  
      case Events.ChatChanged:
      case Events.ChatDetailsChanged:
      case Events.ChatMessagesRemoved:
      case Events.ChatMessageReceived:
      case Events.ChatMessageSendingDone:
      case Events.FileSent:
      case Events.FileReceived:
      case Events.FileProgress:
        msg = WebChatEvent.decode(bytes)
        msg.action = payload.action
        console.log('-- chatchanged', msg)
        this.onchatchanged(msg)
        break
      case Events.ChatTtlChanged:
        msg = WebChatEvent.decode(bytes)
        this.onchatttlchanged(msg)
        break
      case Events.ChatUnreadChanged:
        msg = WebChatEvent.decode(bytes)
        this.onchatunreadchanged(msg)
        break
      case Events.ChatTtlMessageProgress:
        msg = WebChatEvent.decode(bytes)
        this.onchatttlmessageprogress(msg)
        break
      case Events.ChatTypingEvent:
        msg = WebChatEvent.decode(bytes)
        this.onchattypingupdated(msg)
        break
      case Events.ChatMessageUpdated:
        msg = WebChatEvent.decode(bytes)
        this.onchatmessageupdated(msg)
        break
  
      case Events.ConferenceStarted:
      case Events.ConferenceEnded:
      case Events.ConferenceSuspended:
      case Events.ConferenceResumed:
      case Events.IncomingCall:
      case Events.RecentChanged:
        ///EventBus.$emit('call-changed', args)
        break
      case Events.UserListChanged:
        ///args.users = EventBus.getCallUsers()
        ///EventBus.$emit('call-changed', args)
        break
  
      case Events.ShowMessage:
        msg = WebAlertEvent.decode(bytes)
        this.onshowmessage(msg)
        break
      case Events.BlockUserComplete:
        msg = WebStateEvent.decode(bytes)
        console.log('-- blockUserComplete', msg)
        this.onblockusercomplete(msg)
        break
      case Events.UnblockUserComplete:
        msg = WebStateEvent.decode(bytes)
        console.log('-- unblockUserComplete', msg)
        msg.id = msg.contactId
        this.onunblockusercomplete(msg)
        break
      case Events.UnblockUsersComplete:
        msg = WebStateEvent.decode(bytes)
        console.log('-- unblockUsersComplete', msg)
        this.onunblockallcomplete(msg)
        break
  
      case Events.AccountAvatarSet:
        /*if (args.state == 0) {
          // update user profile in store
          store.dispatch('fetchUserProfile')
        }*/
        break
  
      case Events.VerifyUserComplete:
        msg = WebVerifyEvent.decode(bytes)
        console.log('-- verifyUserComplete', msg)
        this.onverifyusercomplete({
          id: msg.contactId,
          result: msg.result,
          name: msg.name,
          fingerprint: msg.fingerprint,
          avatar: (msg.avatar.byteLength > 0)
            ? '' + btoa(String.fromCharCode(...msg.avatar))
            : ''
        })
        break
    }
  }

  onRequestHandler(payload) {
    console.debug('-- payload req:', payload.action)

    const bytes = window.cryptManager.decrypt(this.senderKey, payload.cryptoBox)

    let msg
    switch (payload.action) {
      case Requests.GetContacts:
      case Requests.GetBlockedContacts:
        msg = (bytes.length > 0) ? WebContacts.decode(bytes) : { contacts: [] }
        //console.log('-- GetContacts', msg)
        break

      case Requests.GetChats:
        msg = (bytes.length > 0) ? WebChats.decode(bytes)  : { chats: [] }
        console.log('-- GetChats', msg)
        break
      case Requests.GetChatMessages:
        msg = (bytes.length > 0) ? WebMessages.decode(bytes) : { messages: [] }
        console.log('-- GetChatMessages', msg)
        break
      case Requests.GetChatMessage:
        msg = (bytes.length > 0) ? WebMessage.decode(bytes) : {}
        console.log('-- GetChatMessage', msg)
        break
      case Requests.GetRecentCalls:
        msg = (bytes.length > 0) ? WebCalls.decode(bytes) : { calls: [] }
        console.log('-- GetRecentCalls')
        break
      case Requests.GetUserProfile:
        console.error('-- GetUserProfile')
        break
      
      case Requests.DecodeFile:
        msg = (bytes.length > 0) ? WebFile.decode(bytes) : { data: new Uint8Array() }
        break
        
      case Requests.CreateChat:
      case Requests.RestoreDraft:
      case Requests.GetChatTtl:
      case Requests.GetChatUnreadCount:
      case Requests.GetUnreadCount:
      case Requests.OpenSingleChat:
        msg = (bytes.length > 0) ? WebChat.decode(bytes) : {}
        console.log('-- chat action', payload.action, msg)
        break
      case Requests.RestoreDraft:
        msg = (bytes.length > 0) ? WebChat.decode(bytes) : {}
        break
      
      case Requests.ReadFile:
        console.error('-- ReadFile')
        break
      default:
        console.log('-- payload event:', payload)
    }
    
    if (msg)
      msg.action = payload.action
    this.onreplycallback(msg)
  }

  send(action, request) {
    let cryptoBytes
    if (request) {
      const wr = WebRequest.create(request)
      const bytes = WebRequest.encode(wr).finish()
      console.debug('-- req', wr, request, bytes)

      cryptoBytes = window.cryptManager.encrypt(this.senderKey, bytes)
    }

    const cblen = (cryptoBytes) ? cryptoBytes.length : 0
    let fragmentCount = (cblen > FRAGMENT_LEN) ? (cblen / FRAGMENT_LEN) : 0
    if (cblen % FRAGMENT_LEN) fragmentCount++
    
    let offset = 0
    let fragment = 0
    do {
      const cb = cryptoBytes ? cryptoBytes.subarray(offset, offset + FRAGMENT_LEN) : undefined

      const p = WebPayload.create({
        type: WebPayload.Type.REQUEST,
        action: action,
        cryptoBox: cb,
        token: this.myToken,
        fragment,
        fragmentCount
      })
      console.debug(`-- send [${fragment}][${offset}]`, p)

      const bytes = WebPayload.encode(p).finish()
      this.sendPayload(bytes)
      offset += FRAGMENT_LEN
      fragment++
    } while (fragment < fragmentCount)
  }

  sendPayload(payload, token) {
    if (!token) token = this.senderToken

    const message = WebConMessage.create({
      token: this.senderToken,
      type: WebConMessage.Type.SEND,
      payload: payload
    })
    ///console.log('-- send 1:', message)
    const bytes = WebConMessage.encode(message).finish()
    this.wscs.send(bytes)
    ///console.log('-- send 2:', bytesToHex(bytes), token)
  }

  registerToken(token) {
    if (1 == 0) {
      const message = JSON.stringify({
        type: 'register',
        token: token
      })
      this.wscs.send(message)
      return
    }

    console.log('-- register via protobuf')
    const message = WebConMessage.create({
      token: token,
      type: WebConMessage.Type.REGISTER,
    })
    const bytes = WebConMessage.encode(message).finish()
    console.log('-- reg:', bytesToHex(bytes), token)
    this.wscs.send(bytes)
  }

  buildWebContact(contactId, name, avatar, chatId) {
    return WebContact.create({contactId, name, avatar, chatId})
  }

  buildWebAccountDetails(name, email, phone, avatar) {
    let details = {}
    if (name) details.name = name
    if (email) details.email = email
    if (phone) details.phone = phone
    if (avatar) details.avatar = avatar
    return WebAccountDetails.create(details)
  }

  buildWebExtra(extra) {
    let e = []
    for (let prop in extra) {
      let item = WebExtra.create({key: prop, value: extra[prop]})
      e.push(item)
    }
    console.log('-- buildWebExtra', e)
    return e
  }
}

export default WebClient